module.exports = __webpack_public_path__ + "img/calendar_event.b9ef2671.svg";